export default {"src":"/_next/static/media/pic_01.988947c8.JPG","height":4000,"width":6000,"blurWidth":0,"blurHeight":0};